"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Animations = void 0;
const PIXI = __importStar(require("pixi.js"));
const module_abstract_1 = require("@kennethgomez/module/module.abstract");
const observable_animation_1 = require("./observable-animation/observable-animation");
const ease_in_out_quad_1 = require("./algorithms/ease-in-out-quad");
class Animations extends module_abstract_1.Module {
    _animations;
    _lastId;
    constructor() {
        super();
        this._animations = new Map();
        this._lastId = 0;
    }
    addAnimation(object, property, duration, values, algorithm = ease_in_out_quad_1.easeInOutQuad) {
        const animations = this._getAnimationObjects(object, property, duration, values, algorithm);
        let observable;
        for (const animation of animations) {
            const id = ++this._lastId;
            observable = this._createAnimationObservable(id, animation);
        }
        return observable;
    }
    _createAnimationObservable(id, animation) {
        const observable = new observable_animation_1.ObservableAnimation(id, animation)
            .on('interruption', this._removeAnimation, this)
            .on('finish', this._removeAnimation, this);
        this._animations.set(id, observable);
        return observable;
    }
    _getAnimationObjects(object, property, duration, values, algorithm = ease_in_out_quad_1.easeInOutQuad) {
        return object[property] instanceof PIXI.ObservablePoint
            ? ['x', 'y'].map((p) => ({
                object: object[property], property: p, duration, values, algorithm,
            }))
            : [{
                    object, property, duration, values, algorithm,
                }];
    }
    get() {
        return this._animations;
    }
    _removeAnimation(animation) {
        this._animations.delete(animation.id);
    }
}
exports.Animations = Animations;
